import React from 'react';
import { FullScreen, Minimize, Player, Time, Velocity, Volume } from '../Controls';

import * as S from '../../styles';

interface StaticLayoutProps {
	visible?: boolean;
	volume: number;
	playing: boolean;
	minimized: boolean;
	playbackRate: number;
	playedSeconds: number;
	duration: number;
	progress: number;
	fullscreen?: boolean;
	showMinimize?: boolean;
	showVolume?: boolean;
	showFullscreen?: boolean;
	onTogglePlay: () => void;
	onToggleSound: () => void;
	onToggleMinimized: () => void;
	onToggleFullscreen?: () => void;
	onVolumeChange: (volume: number) => void;
	onPlaybackRateChange: (rate: number) => void;
	onSliderChange: (value: number) => void;
}

export function StaticLayout({
	visible = true,
	volume,
	playing,
	minimized,
	playbackRate,
	playedSeconds,
	duration,
	progress,
	fullscreen = false,
	showMinimize = true,
	showVolume = true,
	showFullscreen = true,
	onTogglePlay,
	onToggleSound,
	onToggleMinimized,
	onToggleFullscreen,
	onVolumeChange,
	onPlaybackRateChange,
	onSliderChange
}: Readonly<StaticLayoutProps>): JSX.Element {
	return (
		<S.ControlsBarWrapper
			$visible={visible}
			onMouseDown={(event) => event.stopPropagation()}
			onClick={(event) => event.stopPropagation()}
		>
			<S.ControlsBar>
				<Player playing={playing} onTogglePlay={onTogglePlay} />
				<Time
					playedSeconds={playedSeconds}
					duration={duration}
					progress={progress}
					handleSliderChange={onSliderChange}
				/>
				{showVolume ? <Volume volume={volume} onToggleSound={onToggleSound} onVolumeChange={onVolumeChange} /> : null}
				<Velocity playbackRate={playbackRate} onPlaybackRateChange={onPlaybackRateChange} />
				{showMinimize ? <Minimize minimized={minimized} onToggleMinimized={onToggleMinimized} /> : null}
				{showFullscreen ? <FullScreen fullscreen={fullscreen} onToggleFullscreen={onToggleFullscreen} /> : null}
			</S.ControlsBar>
		</S.ControlsBarWrapper>
	);
}
